export default (state = {}, action) => {
    let {type, target, payload} = action
    switch(type){
        case 'set':
            return {
                ...state,
                [`${target}`]: payload
            }
        case 'assign':
            return {
                ...state,
                [`${target}`]: {
                    ...state[target],
                    ...payload
                }
            }
        case 'remove':
            delete state[target][payload.id]
            return {
                ...state,
                [`${target}`]: {
                    ...state[target]
                }
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/master.js